import { Modal } from "flowbite-react";
import FormEditExternalServices from "../forms/FormEditExternalServices";
import { emptyExternalServices } from "@/types/external-services.type";

type Props = {
  onClose: () => void;
  onSave?: () => void;
  id: string;
  initial: ReturnType<typeof emptyExternalServices>;
};

export default function EditExternalServicesModal({ onClose, onSave, id, initial }: Props) {
  const handleCloseModal = () => {
    onSave?.();
    onClose();
  };
  return (
    <Modal className='relative text-black' size="5xl" show={true} onClose={onClose}>
      <Modal.Header className='text-black dark:text-black'>
        <h2 className="text-black">Editar serviços externos</h2>
      </Modal.Header>
      <Modal.Body className='text-black dark:text-black'>
        <FormEditExternalServices
          id={id}
          initial={{
            ...initial,
            licensePlate: initial.licensePlate,
          }}
          onSubmit={handleCloseModal}
          onCancel={onClose}
        />
      </Modal.Body>
    </Modal>
  );
}